import { render, staticRenderFns } from "./addSubCourse.vue?vue&type=template&id=2710976e&scoped=true&"
import script from "./addSubCourse.vue?vue&type=script&lang=js&"
export * from "./addSubCourse.vue?vue&type=script&lang=js&"
import style0 from "./addSubCourse.vue?vue&type=style&index=0&id=2710976e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2710976e",
  null
  
)

export default component.exports